import { render, staticRenderFns } from "./AdminCampaignActions.vue?vue&type=template&id=50473137"
import script from "./AdminCampaignActions.vue?vue&type=script&lang=js"
export * from "./AdminCampaignActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports